import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { State } from 'shared/store/types';
import { getMinimalWishlist } from 'shared/store/auth/action';


function Wishlist({
  dataFetched,
  isLoggedIn,
}: {
  dataFetched: boolean;
  isLoggedIn: boolean;
}) {
  const dispatch = useDispatch();
  const isEnabled = useSelector((state: State) => {
    const { switches } = state.remoteConfig;
    return !!switches.fetchWishlistIds;
  });

  useEffect(() => {
    if (dataFetched && isLoggedIn && isEnabled) {
      dispatch(getMinimalWishlist());
    }
  }, [dataFetched, dispatch, isEnabled, isLoggedIn]);

  return (
    <></>
  );
}

export default Wishlist;
